import { Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterTypes, RadioFilter } from '@models/filter-types';

@Pipe({
    name: 'isRadioFilter',
    standalone: false,
})
export class IsRadioFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is RadioFilter<unknown> {
        return value?.Type === FilterTypes.RadioFilterType;
    }
}
